import { render, staticRenderFns } from "./NsSearchbarButton.vue?vue&type=template&id=15c493fe&scoped=true&"
import script from "./NsSearchbarButton.vue?vue&type=script&lang=js&"
export * from "./NsSearchbarButton.vue?vue&type=script&lang=js&"
import style0 from "./NsSearchbarButton.vue?vue&type=style&index=0&id=15c493fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c493fe",
  null
  
)

export default component.exports